import * as yup from 'yup';
import * as regex from '../../../utils/constants/regex';

export const faFormSchema = yup.object({
  empName: yup
    .string()
    .required('Employee Name is required'),
  empCode: yup
    .string()
    .required('Employee Code is required')
    .max(10)
    .matches(
      regex.EMP_CODE,
      'Please enter a valid employee code'
    ), // Pattern msg not present in admin, but should be
  empEmail: yup
    .string()
    .required('Employee Email is required')
    .matches(regex.EMAIL, 'Please enter a valid email'),
  empMobile: yup
    .string()
    .required('Employee Mobile Number is required')
    .length(10, 'Please enter valid number')
    .matches(
      regex.MOBILE_NUMBER,
      'Please enter valid number'
    ),
  empUgdn: yup
    .string()
    .required('Employee UGDN is required')
    .max(10)
    .matches(regex.UGDN, 'Please enter a valid UGDN'), // Pattern msg not present in admin, but should be
  pinCodeFrom: yup
    .string()
    .required('Pincode Start is required')
    .length(6, 'PinCode should be minimum 6 digits'),
  pinCodeTo: yup
    .string()
    .required('Pincode End is required')
    .length(6, 'PinCode should be minimum 6 digits'),
  company: yup.number().required('Company is required'),
  plant: yup.string().required('Depot is required'),
  stateCode: yup.string().required('State is required'),
  salesOffice: yup
    .string()
    .required('Sales Office is required'),
  rmName: yup.string().required('RM Name is required'),
  rmMobile: yup
    .string()
    .required('RM Mobile Number is required')
    .length(10, 'Please enter valid number')
    .matches(
      regex.MOBILE_NUMBER,
      'Please enter valid number'
    ),
  rmEmail: yup
    .string()
    .required('RM Email is required')
    .matches(regex.EMAIL, 'Please enter a valid email'),
  rmUgdn: yup
    .string()
    .required('RM UGDN is required')
    .max(10)
    .matches(regex.UGDN, 'Please enter a valid UGDN'), // Pattern msg not present in admin, but should be
  zmName: yup.string().required('ZM Name is required'),
  zmMobile: yup
    .string()
    .required('ZM Mobile Number is required')
    .length(10, 'Please enter valid number')
    .matches(
      regex.MOBILE_NUMBER,
      'Please enter valid number'
    ),
  zmEmail: yup
    .string()
    .required('ZM Email is required')
    .matches(regex.EMAIL, 'Please enter a valid email'),
  zmUgdn: yup
    .string()
    .required('ZM UGDN is required')
    .max(10)
    .matches(
      regex.UGDN,
      'Please enter a valid UGDN' // Pattern msg not present in admin, but should be
    ),
  territoryName: yup
    .string()
    .required('Territory Name is required'),
  territoryCode: yup
    .string()
    .required('Territory Code is required')
    .max(10),
  regionName: yup
    .string()
    .required('Region Name is required'),
  regionCode: yup
    .string()
    .required('Region Code is required')
    .max(10),
  zoneName: yup.string().required('Zone Name is required'),
  zoneCode: yup
    .string()
    .required('Zone Code is required')
    .max(10),
  plantName: yup.string(),
});

export type TFAFormData = yup.InferType<
  typeof faFormSchema
>;
